import React from 'react'

import { HOMEPAGE_URL, SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
import { LOGO_URL } from 'consts/mediaUrls'

import SidebarItem from './SidebarItem'
import * as Styled from './styled'
import { useResponsive } from 'hooks/useResponsive'
import useSidebarData from './useSidebarData'

const Sidebar: React.FC = () => {
  const sidebarData = useSidebarData()
  const isMobile = useResponsive(SMALL_DESKTOP_SIZE_BREAKPOINT)

  return (
    <Styled.Sidebar>
      {!isMobile && (
        <Styled.SidebarLogoWrapper href={HOMEPAGE_URL}>
          <img src={LOGO_URL} alt="Logo" />
        </Styled.SidebarLogoWrapper>
      )}
      {sidebarData.map(item => (
        <Styled.SidebarItemWrapper
          key={item.key}
          onClick={() => item.onClick()}
          $isActive={item.isActive}
          data-test-id={item.tabTestId}
        >
          <SidebarItem
            icon={item.icon}
            label={item.label}
            isActive={item.isActive}
            isNewLabel={item.isNewLabel}
          />
        </Styled.SidebarItemWrapper>
      ))}
    </Styled.Sidebar>
  )
}

export default Sidebar
